<script lang="ts" setup>
import { computed } from 'vue'
import {
	ButtonNormalTheme,
	ButtonSize,
	RippleTheme,
} from '@/types/ButtonLegacy'
import BsRipple from '@/legacy/components/Ripple.vue'

const props = defineProps({
	theme: {
		type: String,
		default: ButtonNormalTheme.Normal,
	},
	text: {
		type: String,
		required: true,
	},
	action: {
		type: Function,
	},
	isDisabled: {
		type: Boolean,
		default: false,
	},
	isError: {
		type: Boolean,
		default: false,
	},
	errorMessage: {
		type: String,
		default: '',
	},
	isRoundEdge: {
		type: Boolean,
		default: true,
	},
	size: {
		type: String,
		default: ButtonSize.Medium,
	},
	isFullWidth: {
		type: Boolean,
		default: false,
	},
})

function onClick() {
	if (props.isDisabled || props.action === undefined) {
		return
	}

	props.action()
}

const rippleTheme = computed(() => {
	if (
		props.theme === ButtonNormalTheme.Normal ||
		props.theme === ButtonNormalTheme.NaturalLarge ||
		props.theme === ButtonNormalTheme.NaturalMedium
	) {
		return RippleTheme.Dark
	}

	return RippleTheme.Light
})

const isShowRipple = computed(() => {
	return (
		!props.isDisabled &&
		props.theme !== ButtonNormalTheme.Social &&
		props.theme !== ButtonNormalTheme.Revamp
	)
})
</script>

<template>
	<div
		class="bs-button-normal__wrapper"
		:class="[
			`bs-button-normal__wrapper--${theme}`,
			`bs-button-normal__size--${size}`,
			{ 'bs-button-normal--is-full-width': isFullWidth },
		]"
	>
		<a
			href="javascript:void(0)"
			class="bs-button-normal"
			:class="{
				'bs-button-normal--disabled': isDisabled,
				'bs-button-normal--round-edge': isRoundEdge,
			}"
			@click.stop="onClick"
		>
			<BsRipple v-show="isShowRipple" :theme="rippleTheme" />
			<span class="bs-button-normal__leading" v-if="$slots.leading">
				<slot name="leading"></slot>
			</span>
			<span class="bs-button-normal__text">{{ text }}</span>
			<span class="bs-button-normal__trailing" v-if="$slots.trailing">
				<slot name="trailing"></slot>
			</span>
		</a>
		<span
			v-if="errorMessage !== '' && isError"
			class="bs-button-normal__message"
		>
			{{ errorMessage }}
		</span>
	</div>
</template>
